module.exports = __webpack_public_path__ + "static/img/5842_phase_function_Paper_PointsHejduk_Prediction.ffd3090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5842_phase_function_Paper_PointsHejduk_Prediction.png
// module id = IPGa
// module chunks = 0